module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sites","button":"Add a site","all":"All"}}')
  delete Component.options._Ctor
}
